import React, { useState, useEffect } from "react";
import styles from "./styles/ContactUs.module.css";
import mailImg from "./styles/img/mail.png";
import { Socials } from "../../Socials/Socials";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { submitCaptcha } from "../../../Utils/captcha";
import config from "../../../config";
import data from "../../../data/multilanguage.json";
import parse from "html-react-parser";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
const base_url = config.base_url;
export function ContactUs() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  useEffect(() => {
    scrollToTop();
    window?.Intercom('show')
  }, []);

  const [form, setForm] = useState("");
  const navigate = useNavigate();

  const [error, setError] = useState({
    email: null,
    reason: null,
    message: null,
    generic:null
  });

  const resetError = () => {
    Object.keys(error).forEach((key) => {
      setError((prevError) => ({ ...prevError, [key]: null }));
    });
  };

  const [formData, setFormData] = useState({
    id: useAuth().user_id,
    email: useAuth().email,
    reason: "",
    message: "",
  });
  const sendContactForm = () => {
    return new Promise((resolve, reject) => {
      submitCaptcha()
        .then((token) => {
          return fetch(base_url + "contactus", {
            method: "POST",
            mode: "cors",
            headers: {
              Accept: "application/json, text/plain, */*",
              "Content-Type": "application/json",
              credentials: "include",
            },
            body: JSON.stringify({ ...formData, token: token }),
            credentials: "include",
          });
        })
        .then((res) => {
          if (res.status === 200) resolve();
          else reject("An error occurred");
        })
        .catch((e) => {
          reject("An error occurred while submitting the data");
        });
    });
  };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const maxMessageLength = 2000; // Define the maximum character length for the message field

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    console.log(formData);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    resetError();

    const newErrors = {};

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(formData["email"])) {
      newErrors.email = dublicatedcontent?.dublicatedText47;
    }

    if (formData.reason === "") {
      newErrors.reason = dublicatedcontent?.please_choose_contact_reason
    }

    if (formData.message === "" || formData.message.length < 20) {
      newErrors.message = dublicatedcontent?.please_elaborate_more_your_issue
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      setTimeout(() => {
        Object.keys(error).forEach((key) => {
          setError((prevError) => ({ ...prevError, [key]: null }));
        });
      }, 5000);
    } else {
      // Add code to handle form submission here
      try {
        setButtonDisabled(true)
        await sendContactForm();
        setIsSubmitted(true);
      } catch (error) {
        console.error("Form submission error:", error);
        setError({...error, "generic":dublicatedcontent?.dublicatedText78})
        setTimeout(() => {
            setError({ ...error, "generic": null });
        }, 5000);
      } finally{
        setButtonDisabled(false)
      }
    }
  };
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.pages.ContactUs
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.pages.ContactUs);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const isCustomer = useAuth().email;
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const reasons = [
    content.contactUsSelectionOption1,
    content.contactUsSelectionOption2,
    content.contactUsSelectionOption3,
    content.contactUsSelectionOption4,
    content.contactUsSelectionOption5,
    dublicatedcontent.dublicatedText34,
    content.contactUsSelectionOption7,
  ];
  return (
    <div className={styles.main}>
      <h1 className={styles.page_title}>
        {dublicatedcontent.dublicatedText35}
      </h1>
      <div className={styles.container}>
        <div className={styles.left}>
          {isSubmitted ? (
            <div className={styles.form_send}>
              <div className={styles.send_title}>
                {parse(content.contactUsSubmittedSuccessText1)}
              </div>
              <img alt="" className={styles.send_img} src={mailImg} />
              <div className={styles.send_text}>
                {content.contactUsSubmittedSuccessText2}
              </div>
              <div className={styles.send_email}>{formData.email}</div>
              <div
                onClick={() => navigate("/user/dashboard", { replace: true })}
                className={styles.blue_button}
              >
                {content.contactUsSubmittedSuccessText3}
              </div>
            </div>
          ) : (
            <div className={styles.form_container}>
              <div className={styles.left_title}>
                {content.contactUssubTitle1}
                <img alt="" className={styles.mail_img} src={mailImg} />
              </div>

              <form onSubmit={handleSubmit} className={styles.contact_form}>
                <div className={styles.field}>
                  <div className={styles.label}>{content.contactUsInput1}</div>
                  <input
                    disabled={isCustomer ? true : false}
                    value={formData.id}
                    onChange={handleFieldChange}
                    className={styles.input}
                    type="text"
                    name="id"
                  />
                </div>
                <div className={styles.field}>
                  <div className={styles.label}>{content.contactUsInput2}</div>
                  <input
                    disabled={isCustomer ? true : false}
                    value={formData.email}
                    onChange={handleFieldChange}
                    className={`${styles.input} ${
                      error.email ? styles.error_field : ""
                    }`}
                    type="text"
                    name="email"
                  />
                  {error.email ? (
                    <div className={styles.error_message}>{error.email}</div>
                  ) : null}
                </div>
                <div className={styles.field}>
                  <div className={`${styles.label} ${styles.label_required}`}>
                    {content.contactUsInput3}
                  </div>
                  <select
                    value={formData.reason}
                    onChange={handleFieldChange}
                    className={`${styles.select} ${
                      error.reason ? styles.error_field : ""
                    }`}
                    name="reason"
                  >
                    <option value="">{content?.contactUsInput3}</option>
                    {reasons.map((reason) => (
                      <option key={reason} value={reason}>
                        {reason}
                      </option>
                    ))}
                  </select>
                  {error.reason ? (
                    <div className={styles.error_message}>{error.reason}</div>
                  ) : null}
                </div>
                <div className={styles.field_big}>
                  <div className={`${styles.label} ${styles.label_required}`}>
                    {content.contactUsInput4}
                  </div>
                  <textarea
                    maxlength={maxMessageLength}
                    className={`${styles.textarea} ${
                      error.message ? styles.error_field : ""
                    }`}
                    value={formData.message}
                    onChange={handleFieldChange}
                    name="message"
                    placeholder={content.contactUsInput4Placeholder}
                  ></textarea>
                  <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between' }}>
                  {error.message ? (

                    <div  className={styles.error_message}>{error.message}</div>
                  ) : null}
                    <div
                    style={{textAlign:'right'}}
                    className={`${styles.counter} ${
                      formData.message.length === maxMessageLength
                        ? styles.error_text
                        : ""
                    }`}
                  >
                    {formData.message.length === maxMessageLength ? (
                      <>{content.contactUsInput4InputErrorText1} </>
                    ) : (
                      ""
                    )}
                    {formData.message.length}/{maxMessageLength}{" "}
                    {content.contactUsInput4InputErrorText2}
                    </div>
                  </div>
                  
                  
                </div>
                {messageError && (
                  <p className={styles.error_message}>
                    {content.contactUsInputGeneralErrorMessage}
                  </p>
                )}
                <div className={styles.actions}>
                  <button disabled={buttonDisabled} type="submit" className={styles.blue_button}>
                    {content.contactUsSendButton}
                  </button>
                  <div className={styles.error_message}>{error?.generic}</div>
                </div>
              </form>
            </div>
          )}
        </div>

        <div className={styles.right}>
          <div className={styles.rigth_title}>{content.contactUsInfo1}</div>
          <div className={styles.right_item}>
            <strong>{content.contactUsInfo2}</strong>
            <div>
              <a
                href="mailto:support@ostreon.io"
                className={styles.contact_link}
              >
                support@ostreon.io
              </a>
            </div>
          </div>
          <div className={styles.right_item}>
            <strong>{content.contactUsInfo3}</strong>
            <div>
              <a
                href="mailto:compilance@ostreon.io"
                className={styles.contact_link}
              >
                compliance@ostreon.io
              </a>
            </div>
          </div>
          <div className={styles.right_item}>
            <strong>{content.contactUsInfo4}</strong>
            <div>
              <a href="mailto:DPO@ostreon.io" className={styles.contact_link}>
                DPO@ostreon.io
              </a>
            </div>
          </div>
          <div className={styles.right_item}>
            <strong>{content.contactUsInfo5}</strong>
            <div>
              <a
                href="mailto:complaints@ostreon.io"
                className={styles.contact_link}
              >
                complaints@ostreon.io
              </a>
            </div>
          </div>
          <div className={styles.right_item}>
            <strong>{content.contactUsInfo6}</strong>
            <div>
              <a
                href="mailto:beneficiaries-support@ostreon.io"
                className={styles.contact_link}
              >
                beneficiaries-support@ostreon.io
              </a>
            </div>
          </div>

          <Socials></Socials>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
